(function(){
  function initLosSurenosTracking(){
    const $ = (id) => document.getElementById(id);

    const root = $("ls-track-v3");
    if (!root) return;

    const btn = $("lsBtn");
    const btnTxt = btn ? btn.querySelector(".ls-btn-txt") : null;
    const spinner = btn ? btn.querySelector(".ls-spinner") : null;
    const msg = $("lsMsg");
    const resultRoot = $("lsResult");

    if (!btn || !btnTxt || !spinner || !msg || !resultRoot) return;
    if (root.dataset.lsTrackingInitialized === "true") return;

    root.dataset.lsTrackingInitialized = "true";

    const endpoint = "https://gemini-wishlist.gadget.app/api/tracking/lookup";
    const LOGO_URL = "https://cdn.shopify.com/s/files/1/0641/1393/4395/files/Surenos_06be104797856cc3344b8ed091810778_1.png?v=1770009402";
    const ARAS_TRACKING_BASE = "https://kargotakip.araskargo.com.tr/mainpage.aspx?code=";

    const ICONS = {
      box: '<svg viewBox="0 0 24 24"><path d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9zM12 4.15L6.04 7.5 12 10.85l5.96-3.35L12 4.15zM5 15.91l6 3.38v-6.71L5 9.21v6.7zM13 12.58v6.71l6-3.38v-6.7l-6 3.37z"/></svg>',
      truck: '<svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>',
      check: '<svg viewBox="0 0 490 490"><g><path d="M390.904,416.122c0,12.271-9.953,22.216-22.218,22.216c-12.27,0-22.221-9.945-22.221-22.216 c0-12.271,9.951-22.219,22.221-22.219C380.951,393.904,390.904,403.851,390.904,416.122z"/><circle cx="74.292" cy="416.122" r="22.217"/></g><path d="M486.935,59.781c-5.58-8.377-16.896-10.639-25.272-5.057L414.62,86.083c-5.068,3.381-8.115,9.071-8.115,15.165v261.585 H16.142C7.241,362.833,0,370.074,0,378.976v11.976c0,8.902,7.241,16.143,16.142,16.143h20.299c1.566,0,2.957-1,3.455-2.484 c4.975-14.813,18.796-24.767,34.395-24.767c15.6,0,29.422,9.955,34.394,24.767c0.497,1.484,1.888,2.484,3.455,2.484h218.695 c1.565,0,2.958-1,3.454-2.484c4.974-14.813,18.797-24.767,34.397-24.767c15.596,0,29.42,9.955,34.395,24.767 c0.495,1.484,1.887,2.484,3.453,2.484h20.299c8.902,0,16.147-7.24,16.147-16.143l-0.023-279.948l38.924-25.949 C490.257,79.471,492.521,68.156,486.935,59.781z"/><path d="M325.131,56.273H299.96c-1.438,0-2.606,1.165-2.606,2.604l0.002,19.723c-0.014,0.021-0.102,0.098-0.289,0.098h-17.194 c-0.198,0-0.289-0.077-0.297-0.101v-19.72c0-1.439-1.159-2.604-2.595-2.604h-25.185c-7.462,0-13.537,6.076-13.537,13.542v73.334 c0,7.468,6.075,13.544,13.537,13.544h73.335c7.468,0,13.547-6.076,13.547-13.544V69.815 C338.678,62.349,332.599,56.273,325.131,56.273z"/><path d="M344.049,187.658h-44.433v22.348c0,2.43-1.971,4.4-4.4,4.4h-13.494c-2.432,0-4.4-1.971-4.4-4.4v-22.348h-44.44 c-8.921,0-16.172,7.255-16.172,16.175v111.169c0,8.919,7.251,16.172,16.172,16.172h111.168c8.919,0,16.179-7.253,16.179-16.172 V203.833C360.227,194.913,352.968,187.658,344.049,187.658z"/><path d="M166.952,187.658h-44.433v22.348c0,2.43-1.971,4.4-4.4,4.4h-13.494c-2.432,0-4.4-1.971-4.4-4.4v-22.348h-44.44 c-8.921,0-16.172,7.255-16.172,16.175v111.169c0,8.919,7.251,16.172,16.172,16.172h111.168c8.919,0,16.179-7.253,16.179-16.172 V203.833C183.131,194.913,175.871,187.658,166.952,187.658z"/></svg>',
      fastTruck: '<svg viewBox="0 0 490 490"><circle cx="158.808" cy="191.789" r="14.446"/><path d="M449.228,91.881c-18.694,0-34.436,12.584-39.249,29.74h-18.343c-6.092,0-11.03,4.938-11.03,11.029 c0,6.094,4.938,11.031,11.03,11.031h18.343c4.813,17.156,20.555,29.74,39.249,29.74c22.517,0,40.772-18.252,40.772-40.771 C490,110.135,471.745,91.881,449.228,91.881z"/><path d="M449.824,186.672c-10.619,0-20.052,5.064-26.027,12.904c-3.183,3.711-14.34,15.705-28.986,20.158 c-15.983,4.859-32.241-3.533-32.323-3.576c-6.941-3.764-15.609-1.188-19.372,5.748c-3.76,6.938-0.862,15.066,5.75,19.371 c13.889,9.039,41.815,9.578,54.258,5.797c5.011-1.523,9.69-3.568,13.992-5.881v69.73c0,10.506,4.957,19.846,12.653,25.83v127.914 c0,11.076,8.979,20.055,20.056,20.055c11.077,0,20.057-8.979,20.057-20.055V336.754c7.696-5.984,12.652-15.326,12.652-25.83 v-91.543C482.533,201.316,467.89,186.672,449.824,186.672z"/><path d="M354.974,204.584c11.248,0,15.301,6.238,26.073,6.238c6.088,0,13.171-2.184,13.171-5.445v-23.178 c0-8.082-6.576-14.658-14.658-14.658h-42.08v19.133c0,1.385-1.122,2.506-2.507,2.506H322.96c-1.385,0-2.508-1.121-2.508-2.506 v-19.133h-42.079c-8.082,0-14.658,6.576-14.658,14.658v101.188c0,8.082,6.576,14.658,14.658,14.658H379.56 c8.082,0,14.658-6.576,14.658-14.658v-20.158c0-0.727-0.315-1.416-0.862-1.893c-0.547-0.475-1.271-0.648-1.992-0.59 c-47.621,3.824-69.433-21.543-58.5-43.002C337.056,209.516,345.739,204.584,354.974,204.584z"/><path d="M256.081,348.221h-20.308V20.318c0-8.307-6.735-15.041-15.043-15.041H45.377c-8.307,0-15.041,6.734-15.041,15.041v327.902 H10.027C4.489,348.221,0,352.709,0,358.248v35.514c0,5.539,4.489,10.027,10.027,10.027h246.054c5.538,0,10.028-4.488,10.028-10.027 v-35.514C266.109,352.709,261.619,348.221,256.081,348.221z M60.42,35.361h145.269v312.855H60.42V35.361z"/></svg>',
      flag: '<svg viewBox="0 0 24 24"><path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/></svg>',
      person: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>',
      customerService: '<svg viewBox="0 0 459.668 459.668"><g><path d="M359.574,297.043c-18.204,25.002-47.692,41.286-80.916,41.286h-46.618c-16.104,0-29.818-10.224-35.011-24.534 c-6.41-1.912-12.696-4.394-18.83-7.442c-12.99-6.454-24.785-15.198-35.168-26.03c-67.35,14.796-117.757,74.808-117.757,146.603 v9.384c0,12.9,10.458,23.358,23.358,23.358h362.403c12.9,0,23.358-10.458,23.358-23.358v-9.384 C434.392,371.464,404.309,323.032,359.574,297.043z"/><path d="M118.205,232.178c10.039,0,18.777-5.564,23.304-13.775c0.119,0.325,0.24,0.648,0.362,0.971 c0.036,0.097,0.072,0.194,0.108,0.291c10.62,27.954,31.284,51.388,58.532,61.627c6.59-10.471,18.243-17.435,31.53-17.435h46.618 c4.65,0,8.978-1.312,12.772-3.433c6.372-3.563,12.102-12.602,15.061-17.393c4.735-7.667,8.404-15.788,11.657-24.642 c1.828,3.32,4.342,6.208,7.354,8.471v11.431c0,25.83-21.014,46.845-46.845,46.845H232.04c-8.813,0-15.958,7.145-15.958,15.958 c0,8.814,7.145,15.958,15.958,15.958h46.618c43.429,0,78.761-35.332,78.761-78.761V226.86 c6.46-4.853,10.639-12.577,10.639-21.278v-48.119v-18.452c0-8.88-4.355-16.737-11.042-21.568C351.83,51.816,296.77,0,229.833,0 C162.895,0,107.836,51.816,102.65,117.442c-6.687,4.831-11.042,12.689-11.042,21.568v66.57 C91.608,220.311,103.575,232.178,118.205,232.178z M229.833,31.917c49.552,0,90.423,37.868,95.2,86.185 c-3.136,2.467-5.705,5.62-7.475,9.238c-15.058-39.286-48.672-66.638-87.726-66.638c-39.896,0-72.971,28.292-87.667,66.481 c-0.02,0.052-0.039,0.105-0.059,0.158c-1.77-3.618-4.339-6.771-7.475-9.238C139.411,69.785,180.281,31.917,229.833,31.917z"/></g></svg>'
    };

    function escapeHtml(value){
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function setMsg(text, type="info"){
      msg.style.display = "block";
      msg.classList.toggle("ls-err", type==="error");
      msg.textContent = text;
    }

    function hideMsg(){
      msg.style.display = "none";
      msg.textContent = "";
      msg.classList.remove("ls-err");
    }

    function normalizeOrderNo(raw){
      const t = String(raw || "").trim().replace(/\s+/g,"");
      if(!t) return "";
      return "#" + t.replace(/^#/, "");
    }

    function cleanText(s){
      return String(s || "").replace(/\(shopify\)/ig, "").replace(/\s+/g, " ").trim();
    }

    function cleanArasText(s){
      return String(s || "")
        .replace(/\bSUBE\b/g, "ŞUBE")
        .replace(/\bYUKLEME\b/g, "YÜKLEME")
        .replace(/\bINDIRME\b/g, "İNDİRME")
        .replace(/\bCIKTI\b/g, "ÇIKTI")
        .replace(/\bCIKARILDI\b/g, "ÇIKARILDI")
        .replace(/\s+/g, " ")
        .trim();
    }

    function normalizeForMatch(value){
      return String(value || "")
        .toLocaleUpperCase("tr-TR")
        .replace(/İ/g, "I")
        .replace(/I/g, "I")
        .replace(/Ş/g, "S")
        .replace(/Ğ/g, "G")
        .replace(/Ü/g, "U")
        .replace(/Ö/g, "O")
        .replace(/Ç/g, "C")
        .replace(/Â/g, "A")
        .replace(/Î/g, "I")
        .replace(/Û/g, "U")
        .replace(/[^A-Z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function movementText(movement){
      return normalizeForMatch([
        movement?.unit,
        movement?.action,
        movement?.description,
        movement?.city,
        movement?.district
      ].filter(Boolean).join(" "));
    }

    function fmtTime(s){
      const raw = String(s || "").trim();

      const trMatch = raw.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
      if (trMatch) {
        const day = Number(trMatch[1]);
        const month = Number(trMatch[2]);
        const year = Number(trMatch[3]);
        const hour = Number(trMatch[4]);
        const minute = Number(trMatch[5]);
        const second = Number(trMatch[6] || 0);
        const d = new Date(year, month - 1, day, hour, minute, second);

        if (!isNaN(d.getTime())) {
          try{
            const date = new Intl.DateTimeFormat("tr-TR", { day:"2-digit", month:"short", year:"numeric" }).format(d);
            const time = new Intl.DateTimeFormat("tr-TR", { hour:"2-digit", minute:"2-digit" }).format(d);
            return date + " • " + time;
          }catch{
            return raw.slice(0, 16);
          }
        }
      }

      const d = s ? new Date(s) : null;
      if(!d || isNaN(d.getTime())) return raw.slice(0,16);

      try{
        const date = new Intl.DateTimeFormat("tr-TR", { day:"2-digit", month:"short", year:"numeric" }).format(d);
        const time = new Intl.DateTimeFormat("tr-TR", { hour:"2-digit", minute:"2-digit" }).format(d);
        return date + " • " + time;
      }catch{
        return d.toLocaleString();
      }
    }

    function buildArasTrackingUrl(code){
      const cleanCode = String(code || "").trim();
      if(!cleanCode) return "";
      return ARAS_TRACKING_BASE + encodeURIComponent(cleanCode);
    }

    function isValidCoord(lat, lng){
      if (lat === null || lat === undefined || lat === "") return false;
      if (lng === null || lng === undefined || lng === "") return false;

      const nLat = Number(lat);
      const nLng = Number(lng);

      if (!Number.isFinite(nLat) || !Number.isFinite(nLng)) return false;
      if (nLat === 0 && nLng === 0) return false;
      if (Math.abs(nLat) > 90 || Math.abs(nLng) > 180) return false;

      return true;
    }

    function getLatestMovement(movements){
      if (!Array.isArray(movements) || movements.length === 0) return null;
      return movements.find(m => m && m.isLatest) || movements[movements.length - 1];
    }

    function isDeliveredMovement(movement){
      const text = movementText(movement);
      return (
        text.includes("TESLIM EDILDI") ||
        text.includes("TESLIM EDILMISTIR") ||
        text.includes("ALICIYA TESLIM")
      );
    }

    function isOutForDeliveryMovement(movement){
      const text = movementText(movement);
      return (
        text.includes("DAGITIMA CIKTI") ||
        text.includes("DAGITIMA CIKARILDI") ||
        text.includes("DAGITIMDA") ||
        text.includes("KURYE DAGITIM")
      );
    }

    function isDeliveryBranchMovement(movement){
      const text = movementText(movement);
      return (
        text.includes("TESLIMAT SUBESINDE") ||
        text.includes("TESLIMAT SUBESINE") ||
        text.includes("TESLIMAT SUBESI") ||
        text.includes("TESLIMAT BIRIMINDE") ||
        text.includes("VARIS SUBESINDE") ||
        text.includes("VARIS SUBESINE")
      );
    }

    function isTransferMovement(movement){
      const text = movementText(movement);
      return (
        text.includes("TRANSFER") ||
        text.includes("AKTARMA") ||
        text.includes("AKTARMADA") ||
        text.includes("HAT ARACI") ||
        text.includes("TORBA") ||
        text.includes("YOLDA") ||
        text.includes("SUBEDE ARAC YUKLEME")
      );
    }

    function deriveShipmentState(data){
      const st = data?.status || {};
      const code = Number(st.code);
      const statusName = normalizeForMatch(st.name || "");
      const movements = Array.isArray(data?.arasMovements) ? data.arasMovements : [];
      const latest = getLatestMovement(movements);
      const opsDeliveryBranchHold = code === 3;

      if (latest) {
        if (isDeliveredMovement(latest)) {
          return {
            step: 5,
            title: "Teslim Edildi",
            help: "Kargonuz teslim edilmiş görünüyor.",
            opsDeliveryBranchHold
          };
        }

        if (isOutForDeliveryMovement(latest)) {
          return {
            step: 4,
            title: "Dağıtıma Çıkarıldı",
            help: "Kargonuz teslimat için dağıtıma çıkarılmış görünüyor.",
            opsDeliveryBranchHold
          };
        }

        if (isDeliveryBranchMovement(latest)) {
          return {
            step: 3,
            title: "Teslimat Şubesinde",
            help: opsDeliveryBranchHold
              ? "Kargonuz teslimat biriminde görünüyor. Dağıtıma çıkmazsa veya şubeden teslim alınması gerekirse taşıyıcı takip ekranından kontrol edebilirsiniz."
              : "Kargonuz teslimat şubesine ulaşmış görünüyor. Bir sonraki aşamada dağıtıma çıkarılacaktır.",
            opsDeliveryBranchHold
          };
        }

        if (isTransferMovement(latest)) {
          return {
            step: 2,
            title: "Transfer Aşamasında",
            help: "Kargonuz Aras Kargo işlem kayıtlarına göre transfer sürecinde ilerliyor.",
            opsDeliveryBranchHold
          };
        }
      }

      if (code === 2 || statusName.includes("TESLIM EDILDI")) {
        return {
          step: 5,
          title: "Teslim Edildi",
          help: "Kargonuz teslim edilmiş görünüyor.",
          opsDeliveryBranchHold
        };
      }

      if (code === 4 || statusName.includes("DAGITIMA")) {
        return {
          step: 4,
          title: "Dağıtıma Çıkarıldı",
          help: "Kargonuz teslimat için dağıtıma çıkarılmış görünüyor.",
          opsDeliveryBranchHold
        };
      }

      if (code === 3 || statusName.includes("TESLIMAT BIRIMINDE")) {
        return {
          step: 3,
          title: "Teslimat Şubesinde",
          help: "Kargonuz teslimat biriminde görünüyor. Dağıtıma çıkmazsa veya şubeden teslim alınması gerekirse taşıyıcı takip ekranından kontrol edebilirsiniz.",
          opsDeliveryBranchHold: true
        };
      }

      if (code === 17 || code === 16 || statusName.includes("TRANSFER") || statusName.includes("YOLDA")) {
        return {
          step: 2,
          title: st.name || "Transfer Aşamasında",
          help: movements.length > 0
            ? "Kargo hareketleri Aras Kargo işlem kayıtlarına göre güncellenmektedir."
            : "Kargonuz transfer sürecinde görünüyor.",
          opsDeliveryBranchHold
        };
      }

      return {
        step: 1,
        title: st.name || "Hazırlanıyor",
        help: "Kargo bilgileri oluşturuldu. Paket kargo firması tarafından araca yükleme işlemi gördüğünde hareketler burada görünecek.",
        opsDeliveryBranchHold
      };
    }

    function getValidArasMovements(movements){
      if (!Array.isArray(movements)) return [];
      return movements.filter(m => isValidCoord(m.lat, m.lng));
    }

    function uniqueLatLngPoints(points){
      const seen = new Set();
      const out = [];

      points.forEach(p => {
        if (!p || !isValidCoord(p.lat, p.lng)) return;

        const key = `${Number(p.lat).toFixed(4)}|${Number(p.lng).toFixed(4)}`;
        if (seen.has(key)) return;

        seen.add(key);
        out.push(p);
      });

      return out;
    }

    function formatMovementUnit(movement){
      const city = cleanArasText(movement?.city || "");
      const district = cleanArasText(movement?.district || "");
      const unit = cleanArasText(movement?.unit || "");

      if (city && unit && unit.toLocaleUpperCase("tr-TR").includes(city.toLocaleUpperCase("tr-TR"))) {
        return unit;
      }

      if (city && district && unit) {
        return `${city} / ${district} · ${unit}`;
      }

      if (city && unit) {
        return `${city} · ${unit}`;
      }

      if (unit) return unit;
      if (city && district) return `${city} / ${district}`;
      if (city) return city;

      return "";
    }

    function makeRoadLikeSegment(a, b){
      const lat1 = Number(a.lat);
      const lng1 = Number(a.lng);
      const lat2 = Number(b.lat);
      const lng2 = Number(b.lng);

      const dLat = lat2 - lat1;
      const dLng = lng2 - lng1;
      const dist = Math.sqrt((dLat * dLat) + (dLng * dLng));

      if (!Number.isFinite(dist) || dist < 0.015) {
        return [[lat1, lng1], [lat2, lng2]];
      }

      const bend = Math.min(0.085, Math.max(0.025, dist * 0.045));
      const perpLat = -dLng * bend;
      const perpLng = dLat * bend;

      return [
        [lat1, lng1],
        [lat1 + (dLat * 0.30) + perpLat, lng1 + (dLng * 0.30) + perpLng],
        [lat1 + (dLat * 0.62) + (perpLat * 0.45), lng1 + (dLng * 0.62) + (perpLng * 0.45)],
        [lat2, lng2]
      ];
    }

    function buildRoadLikeLine(points){
      const cleanPoints = uniqueLatLngPoints(points);
      const out = [];

      if (cleanPoints.length <= 1) {
        return cleanPoints.map(p => [Number(p.lat), Number(p.lng)]);
      }

      for (let i = 0; i < cleanPoints.length - 1; i++) {
        const segment = makeRoadLikeSegment(cleanPoints[i], cleanPoints[i + 1]);

        if (i > 0) {
          segment.shift();
        }

        segment.forEach(p => out.push(p));
      }

      return out;
    }

    function distanceKm(a, b){
      if (!a || !b || !isValidCoord(a.lat, a.lng) || !isValidCoord(b.lat, b.lng)) return 0;

      const R = 6371;
      const lat1 = Number(a.lat) * Math.PI / 180;
      const lat2 = Number(b.lat) * Math.PI / 180;
      const dLat = (Number(b.lat) - Number(a.lat)) * Math.PI / 180;
      const dLng = (Number(b.lng) - Number(a.lng)) * Math.PI / 180;

      const x =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);

      return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    }

    function routeDistanceKm(points){
      const cleanPoints = uniqueLatLngPoints(points);
      let total = 0;

      for (let i = 0; i < cleanPoints.length - 1; i++) {
        total += distanceKm(cleanPoints[i], cleanPoints[i + 1]);
      }

      return total;
    }

    function getRouteMaxZoom(points){
      const km = routeDistanceKm(points);

      if (km <= 3) return 14;
      if (km <= 10) return 13;
      if (km <= 30) return 12;
      if (km <= 80) return 10;
      if (km <= 180) return 9;
      if (km <= 350) return 8;

      return 7;
    }

    function enrichMovementsForMap(movements, senderPoint, recipientPoint){
      if (!Array.isArray(movements)) return [];

      return movements.map((movement, index) => {
        if (isValidCoord(movement?.lat, movement?.lng)) return movement;

        const isFirst = index === 0;
        const needsRecipientFallback =
          isDeliveryBranchMovement(movement) ||
          isOutForDeliveryMovement(movement) ||
          isDeliveredMovement(movement);

        if (isFirst && senderPoint && isValidCoord(senderPoint.lat, senderPoint.lng)) {
          return {
            ...movement,
            lat: senderPoint.lat,
            lng: senderPoint.lng,
            city: movement?.city || senderPoint.city || null,
            district: movement?.district || senderPoint.district || null,
            locationSource: "ui_sender_fallback"
          };
        }

        if (needsRecipientFallback && recipientPoint && isValidCoord(recipientPoint.lat, recipientPoint.lng)) {
          return {
            ...movement,
            lat: recipientPoint.lat,
            lng: recipientPoint.lng,
            city: movement?.city || recipientPoint.city || null,
            district: movement?.district || recipientPoint.district || null,
            locationSource: "ui_recipient_fallback"
          };
        }

        return movement;
      });
    }

    let map = null;
    let markers = [];
    let line = null;

    function destroyMap(){
      try{ if(map) map.remove(); }catch(e){}
      map = null;
      markers = [];
      line = null;
    }

    function mkCustomIcon(type){
      if (type === "sender") {
        return L.divIcon({
          className: "",
          html: `
            <div style="width:36px;height:36px;border-radius:50%;background:#fff;border:2px solid #fff;box-shadow:0 6px 14px rgba(0,0,0,0.25);overflow:hidden;display:flex;align-items:center;justify-content:center;">
              <img 
                src="${LOGO_URL}" 
                style="width:100%;height:100%;object-fit:cover;display:block;"
                onerror="this.outerHTML='<span style=&quot;font-size:10px;font-weight:800;color:#111;letter-spacing:-.04em;&quot;>LS</span>';"
              >
            </div>`,
          iconSize:[36,36],
          iconAnchor:[18,18],
        });
      }

      if (type === "latest") {
        return L.divIcon({
          className: "",
          html: `
            <div style="width:38px;height:38px;border-radius:50%;background:#16a34a;border:3px solid #fff;box-shadow:0 10px 20px rgba(22,163,74,.34);display:flex;align-items:center;justify-content:center;color:#fff;">
              <div style="width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 0 0 5px rgba(255,255,255,.22);"></div>
            </div>`,
          iconSize:[38,38],
          iconAnchor:[19,19],
        });
      }

      if (type === "movement") {
        return L.divIcon({
          className: "",
          html: `
            <div style="width:24px;height:24px;border-radius:50%;background:#111;border:3px solid #fff;box-shadow:0 7px 14px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center;">
              <div style="width:7px;height:7px;border-radius:50%;background:#fff;"></div>
            </div>`,
          iconSize:[24,24],
          iconAnchor:[12,12],
        });
      }

      return L.divIcon({
        className: "",
        html: `
          <div style="width:32px;height:32px;border-radius:50%;background:#111;border:2px solid #fff;box-shadow:0 6px 12px rgba(0,0,0,0.2);display:flex;align-items:center;justify-content:center;color:#fff;">
            <div style="width:18px;height:18px;">${ICONS.person}</div>
          </div>`,
        iconSize:[32,32],
        iconAnchor:[16,16],
      });
    }

    function addMarker(point, type){
      if (!point || !isValidCoord(point.lat, point.lng)) return null;

      const marker = L.marker([Number(point.lat), Number(point.lng)], { icon: mkCustomIcon(type) }).addTo(map);

      if (type === "latest") marker.setZIndexOffset(1000);
      if (type === "sender") marker.setZIndexOffset(800);
      if (type === "recipient") marker.setZIndexOffset(700);

      if (point.popup) {
        marker.bindPopup(point.popup);
      }

      markers.push(marker);
      return marker;
    }

    function buildMovementPopup(movement){
      const unit = escapeHtml(cleanArasText(movement?.unit || ""));
      const action = escapeHtml(cleanArasText(movement?.action || ""));
      const date = escapeHtml(fmtTime(movement?.at || ""));
      const desc = escapeHtml(cleanArasText(movement?.description || ""));

      return `
        <div style="font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;min-width:190px;">
          <div style="font-size:12px;color:rgba(20,20,20,.58);margin-bottom:4px;">${date}</div>
          ${unit ? `<div style="font-size:13px;font-weight:700;color:#111;margin-bottom:4px;">${unit}</div>` : ""}
          ${action ? `<div style="font-size:13px;color:#111;margin-bottom:4px;">${action}</div>` : ""}
          ${desc ? `<div style="font-size:12px;color:rgba(20,20,20,.62);line-height:1.4;">${desc}</div>` : ""}
        </div>
      `;
    }

    function drawMap(geo, arasMovements){
      const el = $("lsMap");
      if(!el || !window.L) return;

      destroyMap();

      map = L.map("lsMap", { zoomControl:true, attributionControl:false });

      L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", { maxZoom:19 }).addTo(map);

      const s = geo?.sender || {};
      const r = geo?.recipient || {};

      const senderPoint = isValidCoord(s.lat, s.lng)
        ? {
            lat:Number(s.lat),
            lng:Number(s.lng),
            city:s.city || null,
            district:s.district || null,
            popup:`<b>Gönderici</b><br>${escapeHtml(s.city || "—")} / ${escapeHtml(s.district || "")}`
          }
        : null;

      const recipientPoint = isValidCoord(r.lat, r.lng)
        ? {
            lat:Number(r.lat),
            lng:Number(r.lng),
            city:r.city || null,
            district:r.district || null,
            popup:`<b>Alıcı</b><br>${escapeHtml(r.city || "—")} / ${escapeHtml(r.district || "")}`
          }
        : null;

      const mapMovements = enrichMovementsForMap(arasMovements, senderPoint, recipientPoint);
      const validMovements = getValidArasMovements(mapMovements);

      if (validMovements.length > 0) {
        if (senderPoint) addMarker(senderPoint, "sender");

        validMovements.forEach((movement, index) => {
          const isLatest = movement.isLatest || index === validMovements.length - 1;

          addMarker({
            lat:Number(movement.lat),
            lng:Number(movement.lng),
            popup:buildMovementPopup(movement)
          }, isLatest ? "latest" : "movement");
        });

        if (recipientPoint) addMarker(recipientPoint, "recipient");

        const progressedPoints = uniqueLatLngPoints([
          senderPoint,
          ...validMovements.map(m => ({
            lat:Number(m.lat),
            lng:Number(m.lng)
          }))
        ]);

        const latestValidMovement = validMovements.find(m => m.isLatest) || validMovements[validMovements.length - 1];

        const futurePoints = uniqueLatLngPoints([
          latestValidMovement ? { lat:Number(latestValidMovement.lat), lng:Number(latestValidMovement.lng) } : null,
          recipientPoint
        ]);

        const progressedLine = buildRoadLikeLine(progressedPoints);
        const futureLine = buildRoadLikeLine(futurePoints);

        if (progressedLine.length > 1) {
          L.polyline(progressedLine, {
            weight:6,
            opacity:0.18,
            color:"#111",
            lineCap:"round",
            lineJoin:"round"
          }).addTo(map);

          L.polyline(progressedLine, {
            weight:3,
            opacity:0.92,
            color:"#111",
            lineCap:"round",
            lineJoin:"round"
          }).addTo(map);
        }

        if (futureLine.length > 1) {
          L.polyline(futureLine, {
            weight:3,
            opacity:0.22,
            color:"#111",
            dashArray:"7, 9",
            lineCap:"round",
            lineJoin:"round"
          }).addTo(map);
        }

        const focusPoints = progressedPoints.length > 0
          ? progressedPoints.map(p => [Number(p.lat), Number(p.lng)])
          : [];

        if (focusPoints.length > 1) {
          const dynamicMaxZoom = getRouteMaxZoom(progressedPoints);

          try {
            map.fitBounds(L.latLngBounds(focusPoints), {
              padding:[54,54],
              maxZoom:dynamicMaxZoom
            });
          } catch {
            map.setView(focusPoints[focusPoints.length - 1], dynamicMaxZoom);
          }
        } else if (focusPoints.length === 1) {
          map.setView(focusPoints[0], 13);
        } else if (recipientPoint) {
          map.setView([Number(recipientPoint.lat), Number(recipientPoint.lng)], 13);
        } else {
          map.setView([39.0, 35.0], 5);
        }

        setTimeout(() => { try{ map.invalidateSize(); }catch(e){} }, 200);
        return;
      }

      const pts = [];

      if (senderPoint) {
        pts.push({
          pos:[Number(senderPoint.lat), Number(senderPoint.lng)],
          type:"sender",
          popup:senderPoint.popup,
          lat:Number(senderPoint.lat),
          lng:Number(senderPoint.lng)
        });
      }

      if (recipientPoint) {
        pts.push({
          pos:[Number(recipientPoint.lat), Number(recipientPoint.lng)],
          type:"recipient",
          popup:recipientPoint.popup,
          lat:Number(recipientPoint.lat),
          lng:Number(recipientPoint.lng)
        });
      }

      if (pts.length === 0){
        map.setView([39.0, 35.0], 5);
        return;
      }

      pts.forEach(p => {
        const marker = L.marker(p.pos, { icon: mkCustomIcon(p.type) }).addTo(map);
        if (p.type === "sender") marker.setZIndexOffset(800);
        if (p.type === "recipient") marker.setZIndexOffset(700);
        if (p.popup) marker.bindPopup(p.popup);
      });

      const latLngs = pts.map(p => p.pos);

      if (latLngs.length === 2){
        L.polyline(latLngs, {
          weight:3,
          opacity:0.6,
          dashArray:"6, 8",
          color:"#111"
        }).addTo(map);

        const fallbackMaxZoom = getRouteMaxZoom(pts);

        try {
          map.fitBounds(L.latLngBounds(latLngs), {
            padding:[40,40],
            maxZoom:fallbackMaxZoom
          });
        } catch {
          map.setView(latLngs[0], fallbackMaxZoom);
        }
      } else {
        map.setView(latLngs[0], 13);
      }

      setTimeout(() => { try{ map.invalidateSize(); }catch(e){} }, 200);
    }

    function renderOrderItems(items){
      if (!Array.isArray(items) || items.length === 0) return "";

      return `
        <div class="ls-items">
          <div class="ls-miniLabel">Sipariş Ürünleri</div>
          ${items.map(it => {
            const title = escapeHtml(it.title || "Ürün");
            const qty = Number(it.quantity ?? 1);
            const variant = it.variantTitle ? escapeHtml(String(it.variantTitle)) : "";
            const img = it.imageUrl || it.image || "";
            const ph = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Crect width='100%25' height='100%25' fill='none'/%3E%3C/svg%3E";

            return `
              <div class="ls-itemRow">
                <div class="ls-thumb">
                  <img src="${img || ph}" alt="" loading="lazy">
                </div>
                <div class="ls-itemInfo">
                  <div class="ls-itemHeader">
                     <div class="ls-itemTitle">${title}</div>
                     <div class="ls-qtyTxt">x${Number.isFinite(qty) ? qty : 1}</div>
                  </div>
                  ${variant ? `<div class="ls-itemVariant">${variant}</div>` : ""}
                </div>
              </div>
            `;
          }).join("")}
        </div>
      `;
    }

    function renderTimeline(data){
      const arasMovements = Array.isArray(data.arasMovements) ? data.arasMovements : [];
      const tl = Array.isArray(data.timeline) ? data.timeline : [];

      if (arasMovements.length > 0) {
        return `
          <div class="ls-card ls-tl">
            <p class="ls-tlTitle">Hareket Geçmişi</p>
            <div class="ls-tlList">
              ${arasMovements.map(m => {
                const unitLine = formatMovementUnit(m);
                const action = cleanArasText(m.action || "");
                const desc = cleanArasText(m.description || "");

                return `
                  <div class="ls-tlItem">
                    <div class="ls-tlTime">${escapeHtml(fmtTime(m.at))}</div>
                    <div class="ls-tlMarker"><span class="ls-tlDot"></span></div>
                    <div class="ls-tlText">
                      ${unitLine ? `<span class="ls-tlUnit">${escapeHtml(unitLine)}</span>` : ""}
                      <div class="ls-tlAction">${escapeHtml(action || "Kargo hareketi")}</div>
                      ${desc ? `<div class="ls-tlDesc">${escapeHtml(desc)}</div>` : ""}
                    </div>
                  </div>
                `;
              }).join("")}
            </div>
          </div>
        `;
      }

      return `
        <div class="ls-card ls-tl">
          <p class="ls-tlTitle">Hareket Geçmişi</p>
          ${tl.length
            ? `
              <div class="ls-tlList">
                ${tl.map(t => `
                  <div class="ls-tlItem">
                    <div class="ls-tlTime">${escapeHtml(fmtTime(t.at))}</div>
                    <div class="ls-tlMarker"><span class="ls-tlDot"></span></div>
                    <div class="ls-tlText">
                      <div class="ls-tlAction">${escapeHtml(cleanText(t.text))}</div>
                    </div>
                  </div>
                `).join("")}
              </div>
            `
            : `<div style="padding:12px 0;color:var(--ls-muted);">Henüz hareket kaydı yok.</div>`
          }
        </div>
      `;
    }

    function render(data){
      resultRoot.style.display = "block";

      const st = data.status || {};
      const links = data.links || {};
      const geo = data.geo || {};
      const arasMovements = Array.isArray(data.arasMovements) ? data.arasMovements : [];
      const shipmentState = deriveShipmentState(data);

      const currentStep = shipmentState.step;
      const steps = [
        { id:1, label:"Hazırlanıyor", icon: ICONS.box, color:"var(--c-step1)" },
        { id:2, label:"Transferde", icon: ICONS.truck, color:"var(--c-step2)" },
        { id:3, label:"Teslimat şubesinde", icon: ICONS.check, color:"var(--c-step3)" },
        { id:4, label:"Dağıtıma çıkarıldı", icon: ICONS.fastTruck, color:"var(--c-step4)" },
        { id:5, label:"Teslim edildi", icon: ICONS.flag, color:"var(--c-step5)" },
      ];

      const progressPct = Math.max(0, Math.min(100, Math.round(((currentStep - 1) / (steps.length - 1)) * 100)));
      const progressLinePct = Math.round(progressPct * 0.8);

      const stepperHtml = `
        <div class="ls-stepper">
          <div class="ls-rail" style="--ls-progress:${progressPct}%; --ls-progress-line:${progressLinePct}%;">
            ${steps.map(s => {
              let cls = "ls-step";
              if (s.id <= currentStep) cls += " done";
              if (s.id === currentStep) cls += " current";
              if (currentStep === 5 && s.id === 5) cls += " delivered";

              return `
                <div class="${cls}">
                  <div class="ls-bubble">${s.icon}</div>
                  <div class="ls-stepLabel">${s.label}</div>
                </div>
              `;
            }).join("")}
          </div>
        </div>
      `;

      const hasArasMovements = arasMovements.length > 0;

      const navLink = links.navlungoTrackingUrl;
      const postNoHtml = navLink
        ? `<a href="${navLink}" target="_blank" rel="noopener">${escapeHtml(data.postNumber || "—")} ↗</a>`
        : escapeHtml(data.postNumber || "—");

      const carrierTrackingCode = String(data.carrierTrackingCode || "").trim();
      const carrierTrackingUrl = buildArasTrackingUrl(carrierTrackingCode);
      const carrierTrackingHtml = carrierTrackingCode
        ? `<a href="${carrierTrackingUrl}" target="_blank" rel="noopener">${escapeHtml(carrierTrackingCode)} ↗</a>`
        : "Henüz yok";

      const plannedDeliveryDate = data.plannedDeliveryDate || data.arasShipment?.plannedDeliveryDate || "";
      const plannedDeliveryHtml = plannedDeliveryDate
        ? `
            <div class="ls-miniItem ls-fullWidth">
              <div class="ls-miniLabel">Planlanan Teslimat</div>
              <div class="ls-miniVal">${escapeHtml(plannedDeliveryDate)}</div>
            </div>
          `
        : "";

      const supportTrackingNo = data.postNumber || data.carrierTrackingCode || "Gönderi No";

      const topPart = `
        <div class="ls-card">
          <div class="ls-topbar">
            <div style="font-size:13px;color:var(--ls-muted);">Durum</div>
            <h2 class="ls-statusTitle">${escapeHtml(shipmentState.title || st.name || "İşlemde")}</h2>
            <div class="ls-help">${escapeHtml(shipmentState.help || "Kargo hareketleri güncel haliyle aşağıda görünür.")}</div>
          </div>
          ${stepperHtml}
        </div>
      `;

      const detailsPart = `
        <div class="ls-card ls-mini">
          <div class="ls-miniLabel">Gönderi Detayları</div>
          <div class="ls-miniGrid">
            <div class="ls-miniItem">
               <div class="ls-miniLabel">Sipariş No</div>
               <div class="ls-miniVal muted">${escapeHtml(data.referenceId || "—")}</div>
            </div>
            <div class="ls-miniItem">
              <div class="ls-miniLabel">Taşıyıcı</div>
              <div class="ls-miniVal">${escapeHtml(data.carrierName || "—")}</div>
            </div>
            <div class="ls-miniItem ls-fullWidth">
              <div class="ls-miniLabel">Gönderi Takip No</div>
              <div class="ls-miniVal">${postNoHtml}</div>
            </div>
            <div class="ls-miniItem ls-fullWidth">
              <div class="ls-miniLabel">Taşıyıcı Takip Kodu</div>
              <div class="ls-miniVal">${carrierTrackingHtml}</div>
            </div>
            ${plannedDeliveryHtml}
          </div>
          ${renderOrderItems(data.orderItems)}
        </div>
      `;

      const mapPart = `
        <div class="ls-card ls-mapCard">
          <div class="ls-mapTitle">
             <span>Paket Konumu</span>
             <span>${hasArasMovements ? "İlerleyen Rota" : "Canlı Harita"}</span>
          </div>
          <div id="lsMap"></div>
          <div class="ls-locRow">
            <div class="ls-pill">
              <b>Gönderici:</b>
              <span>${escapeHtml(geo.sender?.city || "—")} / ${escapeHtml(geo.sender?.district || "")}</span>
            </div>
            <div class="ls-pill">
              <b>Alıcı:</b>
              <span>${escapeHtml(geo.recipient?.city || "—")} / ${escapeHtml(geo.recipient?.district || "")}</span>
            </div>
          </div>
        </div>
      `;

      const timelineHtml = renderTimeline(data);

      const supportPart = `
        <div class="ls-card ls-support">
          <div class="ls-supIcon">${ICONS.customerService}</div>
          <div class="ls-supContent">
            <div class="ls-supTitle">Teslimatla ilgili yardıma mı ihtiyacınız var?</div>
            <div class="ls-supText">
              Kargonuz dağıtıma çıkmadıysa, adres değişikliği gerekiyorsa veya tekrar dağıtım talep etmek istiyorsanız
              iş ortağımız <b>Navlungo Domestic</b> Müşteri Hizmetleri ile görüşebilirsiniz.
              Lütfen aradığınızda <b>${escapeHtml(supportTrackingNo)}</b> numaralı gönderi kodunu belirtmeyi unutmayın.
            </div>
            <a href="tel:08505327949" class="ls-supBtn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.33 8.5 5.14 8.5 3.91 8.5 3.4 8.1 3 7.6 3H4.21C3.54 3 3 3.54 3 4.21c0 9.14 7.41 16.54 16.54 16.54.67 0 1.22-.54 1.22-1.21v-3.37c0-.51-.4-1.02-.95-1.02z"/></svg>
              0850 532 79 49
            </a>
          </div>
        </div>
      `;

      resultRoot.innerHTML = `
        <div class="ls-result">
          ${topPart}
          <div class="ls-grid">
             <div style="display:grid;gap:14px;">${mapPart} ${timelineHtml}</div>
             <div style="display:grid;gap:14px;align-content:start;">${detailsPart}</div>
          </div>
          ${supportPart}
        </div>
      `;

      setTimeout(() => { drawMap(geo, arasMovements); }, 50);
    }

    async function runLookup(){
      hideMsg();
      resultRoot.style.display = "none";
      resultRoot.innerHTML = "";
      destroyMap();

      const orderNoRaw = $("lsOrderNo").value;
      const emailRaw = $("lsEmail").value;
      const orderNo = normalizeOrderNo(orderNoRaw);
      const email = String(emailRaw || "").trim().toLowerCase();

      if(!orderNo || !email){
        setMsg("Sipariş numarası ve e-posta gerekli.", "error");
        return;
      }

      btn.disabled = true;
      btnTxt.textContent = "Sorgulanıyor...";
      spinner.style.display = "inline-block";

      try{
        const r = await fetch(endpoint, {
          method:"POST",
          headers:{ "Content-Type":"application/json" },
          body:JSON.stringify({ orderNo, email })
        });

        const j = await r.json().catch(() => null);

        if(!j || !j.ok){
          if(j?.code === "NOT_FOUND") setMsg("Sipariş bulunamadı.", "error");
          else setMsg("Hata oluştu. Lütfen tekrar deneyin.", "error");
          return;
        }

        if(j.data && j.data.state === "PENDING"){
          setMsg("Takip bilgisi henüz oluşmadı.", "info");
          resultRoot.style.display = "block";
          resultRoot.innerHTML = `<div class="ls-result"><div class="ls-card ls-mini">${renderOrderItems(j.data.orderItems || [])}</div></div>`;
          return;
        }

        render(j.data);

      }catch(e){
        setMsg("Bağlantı hatası.", "error");
      }finally{
        btn.disabled = false;
        btnTxt.textContent = "Sorgula";
        spinner.style.display = "none";
      }
    }

    btn.addEventListener("click", runLookup);

    $("lsOrderNo").addEventListener("keydown", (e)=>{
      if(e.key==="Enter") runLookup();
    });

    $("lsEmail").addEventListener("keydown", (e)=>{
      if(e.key==="Enter") runLookup();
    });

    $("lsOrderNo").addEventListener("blur", ()=>{
      $("lsOrderNo").value = normalizeOrderNo($("lsOrderNo").value);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLosSurenosTracking);
  } else {
    initLosSurenosTracking();
  }

  document.addEventListener("shopify:section:load", function(){
    const root = document.getElementById("ls-track-v3");
    if (root) {
      root.dataset.lsTrackingInitialized = "false";
      initLosSurenosTracking();
    }
  });
})();